module.exports = __webpack_public_path__ + "static/media/wiser-logo-light-background.11dd9941.png";